import React from 'react';
import BaseModal from "../../../utils/BaseModal";

interface AuthorityConfirmModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: (mfaCode?: string) => void | Promise<void>;
    modifiedCount: number;
    loading?: boolean;
}

/**
 * Confirmation modal for authority changes with MFA support.
 */
const AuthorityConfirmModal: React.FC<AuthorityConfirmModalProps> = ({
                                                                         open,
                                                                         onClose,
                                                                         onConfirm,
                                                                         modifiedCount,
                                                                         loading = false,
                                                                     }) => {
    return (
        <BaseModal
            open={open}
            title="Save Authority Changes"
            onAbort={onClose}
            onSubmit={onConfirm}
            abortText="Cancel"
            submitText="Confirm & Save"
            submitColor="primary"
            loading={loading}
            mfaMode="REQUIRED"
            maxWidth="sm"
        >
            <div className="text-sm text-gray-700 dark:text-gray-300 py-2">
                Are you sure you want to save changes for{' '}
                <strong className="text-gray-900 dark:text-white">{modifiedCount}</strong>{' '}
                authority setting{modifiedCount > 1 ? 's' : ''}?
            </div>
        </BaseModal>
    );
};

export default AuthorityConfirmModal;